export default __webpack_public_path__ + "static/media/235.24dbfcfd.jpg";